import christian from "./headshots/drwade.webp";
import curt from "./headshots/curtheadshot.webp";
export const about = [
  {
    alt: "Dr. Christian Wade",
    image: christian,
    header: "Dr. Christian Wade",
    subheading: "Owner of Concierge Wellness",
    credential: "Physical Therapist and Wellness Coach",
    content: (
      <div>
        Dr. Christian Wade, a native of Fort Worth, TX, discovered his passion
        for helping others at an early age, inspired by his experience growing
        up with an older brother who has Cerebral Palsy. The countless hours
        spent attending physical therapy sessions, participating in church
        groups, and engaging in local events exposed him to the challenges faced
        by individuals with disabilities, igniting a desire to make a positive
        impact.
        <br /> <br />
        Choosing a path away from traditional medication-based solutions, Dr.
        Wade found his calling in physical therapy after personally experiencing
        the benefits following an injury. His educational journey culminated in
        the attainment of a Doctorate from Texas Woman's University in Dallas.
        Eager to broaden his perspective, he embarked on a two-year journey,
        working 10 different physical therapy clinics across 5 states.
        <br /> <br />
        These diverse experiences not only enriched Dr. Wade's understanding of
        the healthcare system but also exposed him to various management styles
        and treatment approaches. Recognizing the need for a paradigm shift
        towards a more holistic and preventative healthcare model, Dr. Wade took
        a bold step by establishing his own practice.
        <br /> <br />
        At the heart of his mission is a commitment to not merely alleviate pain
        but to empower individuals to embrace healthier lifestyles, reducing the
        reliance on unnecessary medical interventions. Dr. Wade firmly believes
        in the body's innate capacity to heal with proper nutrition, exercise,
        and overall wellness. This holistic philosophy permeates every aspect of
        his patient care.
        <br /> <br />
        By standing at the forefront of change, Dr. Wade is pushing the
        healthcare profession in a positive direction. His practice emphasizes
        evidence-based treatment, skilled manual therapy, and comprehensive
        patient education, reflecting his dedication to shaping a healthcare
        landscape that prioritizes holistic well-being and prevention.
        <br /> <br />
        Currently living in Colorado with his wife and child, they relish in the
        beauty of the Rocky Mountains. Their days are filled with shared
        passions, including hiking, mountain biking, camping, snowboarding, and
        fostering a healthy lifestyle through their home gym. These activities
        not only contribute to their physical well-being but also reinforce
        their commitment to the holistic principles that guide his approach to
        healthcare.
        <br /> <br />
        Join Dr. Christian Wade on the journey to a healthier, more balanced
        life, where your body's natural healing abilities are nurtured, and each
        patient is empowered to take charge of their well-being.
      </div>)
    },
    {
    alt: "Curt Mulick",
    image: curt,
    header: "Curt Mulick",
    credential: "Licensed Massage Therapist, Certified Neuromuscular Therapist",
    content: (
      <div>
        My name is Curt Mulick. Before entering this field, I worked as a
        mechanical engineer — an environment where precision, structure, and
        systems thinking were essential. That training continues to influence
        how I evaluate movement, identify compensation patterns, and approach
        each session with careful intention.als with disabilities, igniting a
        desire to make a positive impact.
        <br /> <br />
        Rather than focusing on isolated areas alone, I consider how the body
        functions as an interconnected system — because lasting relief and
        resilient movement rarely come from treating one structure in isolation.
        <br /> <br />
        My transition into bodywork was also shaped by personal experience. When
        persistent back discomfort began interfering with my ability to ride,
        skilled treatment helped restore both comfort and confidence in my
        movement. That experience deepened my respect for thoughtful recovery
        work and its ability to support an active life.
      </div>
    ),
  },
];
